import { render } from "./Index_en.vue?vue&type=template&id=1b2049d6&scoped=true"
import script from "./Index_en.vue?vue&type=script&lang=js"
export * from "./Index_en.vue?vue&type=script&lang=js"

import "./Index_en.vue?vue&type=style&index=0&id=1b2049d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b2049d6"

export default script